export const REDUCER_NAME = 'filterGroups';

export enum FILTER_GROUP_TYPES {
  JURISDICTION = 'JURISDICTION',
  AGENCY = 'AGENCY'
}
